import { render, staticRenderFns } from "./roledescription.vue?vue&type=template&id=67e6e6b9"
import script from "./roledescription.vue?vue&type=script&lang=ts"
export * from "./roledescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports